const { on } = window.ivent;

let timeout;

on(document, 'click', '[data-copy-link]', async (e) => {
	e.preventDefault();
	const button = e.delegateTarget;
	const tooltipAccess = button.querySelector('.button-share-tooltip-access');
	const tooltipError = button.querySelector('.button-share-tooltip-error');

	clearTimeout(timeout);

	try {
		await navigator.clipboard.writeText(button.getAttribute('data-copy-link'));

		tooltipError.classList.remove('show');
		tooltipAccess.classList.add('show');
	} catch (err) {
		tooltipAccess.classList.remove('show');
		tooltipError.classList.add('show');
	}

	timeout = setTimeout(() => {
		tooltipAccess.classList.remove('show');
		tooltipError.classList.remove('show');
	}, 1000);
});
